import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { generateDataTestidAttribute } from '../../services/testid-service';
import { ButtonThemeService } from '../../services/button-theme-service';
import { NotificationCloseButton } from '../notification/notification-close-button';
import { NotificationContent } from '../notification/notification-content';
import { NotificationImage } from '../notification/notification-image';
import { NotificationProgressBar } from '../notification/notification-progress-bar';
import { noop } from '../../default-props/noop';
import { useScreenSizeContext } from '../../../contexts/screen-size-resolution';
import { NOTIFICATION_TYPES, NOTIFICATION_TYPE_INFO } from '../../services/notification-service';
import { emptyArray } from 'ui-components/default-props/empty';

import style from './notification.module.less';
import { MobileToastNotification } from '../mobile-notification/index';

// TODO: SPD-12315 Add error and info states for MobileNotification and remove withMobileStyle prop.
// Making MobileNotification the global path for all notifications when in mobile was out of scope for this ticket. Slowe 1/24/2023

export const Notification = ({
  title = '',
  content,
  id,
  notificationType = NOTIFICATION_TYPE_INFO,
  image = '',
  imageAltText = '',
  buttons = emptyArray,
  progress = false,
  progressPercentage,
  hideCloseButton = false,
  onButtonClick = noop,
  onClick = noop,
  onClose = noop,
  withMobileStyling = false,
  trackNotificationClose = noop,
  hideNotificationForMobile = false,
}) => {
  const { isMobile } = useScreenSizeContext();
  const cssClasses = classnames(style.notification, style[notificationType], {
    [style['has-image']]: image,
  });

  if (withMobileStyling) {
    return (
      <div {...generateDataTestidAttribute(title)}>
        <MobileToastNotification
          content={content}
          id={id}
          notificationType={notificationType}
          onButtonClick={onButtonClick}
          onClick={onClick}
          onClose={onClose}
          trackNotificationClose={trackNotificationClose}
        />
      </div>
    );
  }

  if (hideNotificationForMobile && isMobile) {
    return null;
  }
  return (
    <div className={cssClasses} {...generateDataTestidAttribute(title)}>
      <NotificationProgressBar notificationType={notificationType} progress={progress} progressPercentage={progressPercentage} />
      <NotificationImage image={image} imageAltText={imageAltText} />
      <NotificationContent buttons={buttons} content={content} notificationType={notificationType} onClick={onClick} title={title} />
      <NotificationCloseButton
        hideCloseButton={hideCloseButton}
        id={id}
        notificationType={notificationType}
        trackNotificationClose={trackNotificationClose}
      />
    </div>
  );
};

Notification.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  id: PropTypes.string.isRequired,
  notificationType: PropTypes.oneOf(NOTIFICATION_TYPES),
  image: PropTypes.string,
  imageAltText: PropTypes.string,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.node,
      theme: PropTypes.oneOf(ButtonThemeService.getButtonThemes()),
      callback: PropTypes.func,
    }),
  ),
  progress: PropTypes.bool,
  progressPercentage: PropTypes.number,
  hideCloseButton: PropTypes.bool,
  hideNotificationForMobile: PropTypes.bool,
  onButtonClick: PropTypes.func,
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  trackNotificationClose: PropTypes.func,
  withMobileStyling: PropTypes.bool,
};
